
document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector('.header__columns.spacing-style');

    if (!header) return;

    // Initial margin (you can adjust if needed)
    header.style.transition = "margin-top 0.3s ease";

    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.style.marginTop = "0px";
      } else {
        header.style.marginTop = ""; // Or set to original value like "20px"
      }
    });
  });


  document.addEventListener("DOMContentLoaded", function () {
    const bars = document.querySelectorAll('[class^="ai-bar-fill-"]');

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const bar = entry.target;
          const finalWidth = bar.getAttribute("data-width");
          if (finalWidth) {
            bar.style.width = finalWidth;
          }
          
          obs.unobserve(bar); // prevent it from triggering again
        }
      });
    }, {
      threshold: 0.5 // element must be at least 50% in view
    });

    bars.forEach(bar => {
      observer.observe(bar);
    });
  });

  // Auto-add IDs to li elements for internal page anchor links
  document.addEventListener("DOMContentLoaded", function () {
    const internalPageContent = document.querySelector('.internal-page-content');

    if (internalPageContent && window.location.pathname === '/pages/privacy-policy') {
      // Find all li elements in ul within the content
      const listItems = internalPageContent.querySelectorAll('ul li');

      listItems.forEach((li, index) => {
        // Add ID based on index (1-based to match the anchor links)
        const id = (index + 1).toString();
        li.id = id;
      });

      // Handle smooth scrolling for anchor links
      const anchorLinks = document.querySelectorAll('.internal-page-sidebar a[href^="#"]');

      anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();

          const targetId = this.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            const elementPosition = targetElement.offsetTop;
            const offsetPosition = elementPosition - 80; // Отступ 80px сверху

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
  const internalPageContent = document.querySelector('.internal-page-content');

  if (internalPageContent && window.location.pathname === '/pages/terms') {


    const titleParagraphs = Array.from(internalPageContent.querySelectorAll('p'))
      .filter(p => {
        const strong = p.querySelector('strong');
        if (!strong) return false;
        
        const children = Array.from(p.childNodes);
        const nonTextNonStrong = children.some(node => node.nodeType !== Node.TEXT_NODE && node.tagName !== 'STRONG');
        if (nonTextNonStrong) return false;
        
        const text = strong.textContent.trim();
        const hebrewSectionPattern = /^[\u05D0-\u05EA]\.\s/;
        const isSectionTitle = hebrewSectionPattern.test(text) || text.startsWith('לכל שאלה');
        
        return isSectionTitle;
      });

    titleParagraphs.forEach((p, index) => {
      p.id = (index + 1).toString();
    });

    const anchorLinks = document.querySelectorAll('.internal-page-sidebar a[href^="#"]');

    anchorLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const elementPosition = targetElement.offsetTop;
          const offsetPosition = elementPosition - 80;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
});




  // CUSTOM Animated Stats Counter for SP Our Stats Count section in Our-Scientists page
  document.addEventListener("DOMContentLoaded", function () {
    const statNumbers = document.querySelectorAll('.stat-number');

    function parseNumberAndFormat(originalText) {
      // Extract numeric value and preserve formatting
      const numericMatch = originalText.match(/\d+/);
      if (!numericMatch) return null;
      
      let targetValue = parseInt(numericMatch[0]);
      
      // Handle K, M multipliers
      if (originalText.includes('K')) targetValue *= 1000;
      if (originalText.includes('M')) targetValue *= 1000000;
      
      return {
        target: targetValue,
        prefix: originalText.substring(0, numericMatch.index),
        suffix: originalText.substring(numericMatch.index + numericMatch[0].length)
      };
    }

    function animateNumber(element, numberData, duration = 2000) {
      const start = 0;
      const startTime = performance.now();
      
      function updateNumber(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function for smooth animation (ease-out)
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const current = Math.floor(start + (numberData.target - start) * easeOutQuart);
        
        element.textContent = numberData.prefix + current.toLocaleString() + numberData.suffix;
        
        if (progress < 1) {
          requestAnimationFrame(updateNumber);
        } else {
          // Ensure we end with the exact original text
          element.textContent = element.dataset.original;
        }
      }
      
      requestAnimationFrame(updateNumber);
    }

    const statsObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const statElement = entry.target;
          const originalText = statElement.dataset.original;
          const numberData = parseNumberAndFormat(originalText);
          
          if (numberData) {
            animateNumber(statElement, numberData);
          }
          
          obs.unobserve(statElement); // prevent it from triggering again
        }
      });
    }, {
      threshold: 0.5 // element must be at least 50% in view
    });

    statNumbers.forEach(stat => {
      statsObserver.observe(stat);
    });
  });



  function moveAddToCartButtons() {
  document.querySelectorAll('[id^="product-card-"]').forEach(function(card) {
    const btn = card.querySelector('.card-gallery__add-to-cart-btn');
    const content = card.querySelector('.product-card__content');
    if (btn && content && btn.parentElement !== content) {
      content.appendChild(btn);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  moveAddToCartButtons();
  // הרץ שוב אחרי 500ms למקרה שהקארוסל טוען לאט
  setTimeout(moveAddToCartButtons, 500);
  setTimeout(moveAddToCartButtons, 1500);
});

const _productCardObserver = new MutationObserver(function(mutations) {
  let shouldRun = false;
  mutations.forEach(function(m) {
    if (m.addedNodes.length) shouldRun = true;
  });
  if (shouldRun) moveAddToCartButtons();
});
_productCardObserver.observe(document.body, { childList: true, subtree: true });







/* === Short Description in ALL Product Cards === */
/* === Short Description in ALL Product Cards - FINAL === */
(function(){
  function addShortDesc(){
    document.querySelectorAll('product-card[data-product-id]').forEach(function(card){
      if(card.querySelector('.seq-short-desc')) return;
      if(card.getAttribute('data-desc-done')) return;
      card.setAttribute('data-desc-done','1');

      var parentLi = card.closest('li[data-short-desc]');
      if(parentLi && parentLi.getAttribute('data-short-desc')){
        insertDesc(card, parentLi.getAttribute('data-short-desc'));
        return;
      }

      var link = card.querySelector('a[href*="/products/"]');
      if(!link) return;
      var href = link.getAttribute('href');
      var slug = href.split('/products/')[1];
      if(!slug) return;
      slug = slug.split('?')[0].split('#')[0];

      fetch('/products/' + slug + '?sections=seq-meta')
        .then(function(r){return r.json()})
        .then(function(data){
          var text = data['seq-meta'] || '';
          text = text.replace(/<[^>]*>/g,'').trim();
          if(text) insertDesc(card, text);
        }).catch(function(){});
    });
  }

function insertDesc(card, text){
    if(!text || card.querySelector('.seq-short-desc')) return;
    var target = card.querySelector('.group-block-content');
    if(!target) return;
    
    target.style.display = 'flex';
    target.style.flexDirection = 'column';
    target.style.alignItems = 'stretch';
    target.style.setProperty('align-items', 'stretch', 'important');
    
    var children = target.children;
    for(var i = 0; i < children.length; i++){
      children[i].style.width = '100%';
      children[i].style.textAlign = 'right';
    }



// Fix price alignment
    var allH6 = card.querySelectorAll('.h6');
    for(var j = 0; j < allH6.length; j++){
      allH6[j].style.alignSelf = 'stretch';
      allH6[j].style.textAlign = 'right';
    }

// Fix price alignment - delayed for web component render
    function fixPrice(){
      var priceDivs = card.querySelectorAll('product-price div');
      if(priceDivs.length === 0) return setTimeout(fixPrice, 300);
      priceDivs.forEach(function(d){ d.style.setProperty('text-align', 'right', 'important'); });
      card.querySelectorAll('product-price').forEach(function(d){
        d.style.setProperty('display', 'block', 'important');
        d.style.setProperty('text-align', 'right', 'important');
      });
    }
    fixPrice();

    var el = document.createElement('p');
    el.className = 'seq-short-desc';
    el.textContent = text;
    el.style.fontSize = '13px';
    el.style.lineHeight = '1.4';
    el.style.color = '#666';
    el.style.margin = '4px 0 0';
    el.style.direction = 'rtl';
    el.style.textAlign = 'right';
    el.style.width = '100%';
    el.style.overflow = 'hidden';
    el.style.display = '-webkit-box';
    el.style.webkitLineClamp = '2';
    el.style.webkitBoxOrient = 'vertical';
    target.appendChild(el);
  }



  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(addShortDesc, 1000); });
  } else {
    setTimeout(addShortDesc, 1000);
  }
  new MutationObserver(function(){ setTimeout(addShortDesc, 500); }).observe(document.body,{childList:true,subtree:true});
})();